import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
import { CaretSortIcon } from '../../../design/static/icons/CaretSortIcon';

interface IGHeaderProps {
  name?: string | ReactNode;
  width?: string;
  className?: string;
  tooltip?: string;
  orderType?: string;
  sticky: boolean | undefined;
  onSortChanged?: (orderType: string) => Promise<void>;
  headerRenderer?: () => ReactNode;
}

const sortingOrderTypes = ['', 'asc', 'desc'];

export const GHeader = observer((props: IGHeaderProps): ReactElement => {
  const handleSortingClick = (): void => {
    if (!props.onSortChanged) {
      return;
    }

    let index = sortingOrderTypes.findIndex((o) => o === props.orderType);

    if (index === -1) {
      index = 0;
    }

    void props.onSortChanged(sortingOrderTypes[(index + 1) % 3]);
  };

  const orderTypeLower = props.orderType?.toLocaleLowerCase();

  return (
    <th
      className={classNames('g-header', props.className, { sortable: props.onSortChanged, sticky: props.sticky })}
      css={{ width: props.width }}
      title={props.tooltip}
      onClick={handleSortingClick}
    >
      <div className='g-header-content'>
        {props.headerRenderer ? props.headerRenderer() : props.name}
        {props.onSortChanged && <CaretSortIcon className={classNames('sort-icon', { up: orderTypeLower === 'asc', down: orderTypeLower === 'desc' })} />}
      </div>
    </th>
  );
});
